import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BalanceService } from 'src/app/services/balance.service';
import { environment } from 'src/environments/environment';

declare var pfWallet;

@Component({
  selector: 'app-paguelo-facil',
  templateUrl: './paguelo-facil.component.html',
  styleUrls: ['./paguelo-facil.component.scss'],
})
export class PagueloFacilComponent implements OnInit {
  @Input() orderId: string;
  @Input() set amount(value: number) {
    if (value) {
      this._vAmount = value;
    }
  }

  @Output() finish$ = new EventEmitter();

  private _vAmount: number = 0;
  private _vPaymentUrl = '';

  get vPaymentUrl() {
    return this._vPaymentUrl;
  }

  constructor(private http: HttpClient, private balanceSv: BalanceService) {}

  ngOnInit() {
    console.log('aqui');
    // SI EXISTE EL METODO ENTONCES AGREGO EL SCRIPT PARA CARGARLO
    const script = document.createElement('script');
    script.onload = () => {
      this.loadConfiguration();
    };
    script.src =
      'https://secure.paguelofacil.com/HostedFields/vendor/scripts/WALLET/PFScript.js';
    script.async = true;
    document.body.appendChild(script);
  }

  loadConfiguration() {
    // SDK JAVASCRIPT DE PAGUELO FACIL
    pfWallet
      .openService({
        apiKey: 'SlLmEttBcJBgyYjIq4CasgIEsOtrFaZm|DIRxdQDwNrnAc6f1CYNHhG1ah',
        cclw: '821A28E007F487A4973C5C9384A5ECCEFE5088C06AD8549D324FDFF67ECE9DE486D7C0E041AB77B45C205018F957CA09B9CDB87EF53D9D9A829109B85A160217',
      })
      .then(
        (merchantSetup) => {
          console.log(merchantSetup);
          this.startMerchantForm(merchantSetup);
        },
        (error) => {
          console.log(error);
        }
      );
  }

  startMerchantForm(merchantSetup) {
    let paymentInfo = {
      amount: parseFloat(this._vAmount.toString()),
      discount: 0.0,
      taxAmount: 0.0,
      description: 'Pago de servicios',
    };
    console.log('merchantSetup', merchantSetup);
    let setup = {
      lang: 'es',
      embedded: true,
      container: 'container-form',
      onError: function (data) {
        console.error('errors', data);
      },
      onTxSuccess: function (data) {
        console.log('onTxSuccess', data);
        window.location.href =
          pfWallet.pfHostViews + `/pf/default-receipt/${data?.Oper}`;
      },
      onTxError: function (data) {
        console.error('when the onTxError, in other process', data);
      },
      onClose: function () {
        console.log('onClose called');
      },
    };
    merchantSetup.init(merchantSetup.dataMerchant, paymentInfo, setup);
  }

  async sendPayment(cart: string) {
    const url = environment.production
      ? 'https://secure.paguelofacil.com'
      : 'https://sandbox.paguelofacil.com';

    const obj = {
      amount: this._vAmount,
      type: 'paguelofacil',
      currency:
        this.balanceSv.currency?.symbol || this.balanceSv.currencyBaseName,
      orderId: this.orderId,
      domainId: environment.domainId,
    };

    const body: any = {
      CCLW: environment.production
        ? '821A28E007F487A4973C5C9384A5ECCEFE5088C06AD8549D324FDFF67ECE9DE486D7C0E041AB77B45C205018F957CA09B9CDB87EF53D9D9A829109B85A160217'
        : 'D00E190DE8A6ED5C0CB0ABF4A970AE6BC69ED7A8D001BB029A395BE05C02741FCACFD7448D285BCE4FC79BCC2DA1090DCA18EA2C3C7A7CDE650508E07D492462',
      CMTN: this._vAmount,
      CDSC: `Continua tu pago de ${environment.domainName}`,
      RETURN_URL: this.stringToHex(
        `${environment.webSiteUrl}/home?successPaym=1&ori=${btoa(
          JSON.stringify(obj)
        )}&cart=${cart}`
      ),
    };

    const queryParams = new URLSearchParams(body).toString();

    this.http.post(`${url}/LinkDeamon.cfm?${queryParams}`, body).subscribe(
      (res: any) => {
        location.href = res.data.url;
      },
      (err) => {
        console.error(err);
      }
    );
  }

  stringToHex(str) {
    let hex = '';
    for (let i = 0; i < str.length; i++) {
      hex += str.charCodeAt(i).toString(16);
    }
    return hex;
  }

  continue() {
    this.finish$.emit('paguelofacil');
  }
}
